// extracted by mini-css-extract-plugin
export var author = "index-module--author--LJmMe";
export var authorDateContainer = "index-module--authorDateContainer--+BReD";
export var date = "index-module--date--o7Rh8";
export var defaultImageContainer = "index-module--defaultImageContainer--tzfs6";
export var defaultImageInnerContainer = "index-module--defaultImageInnerContainer--FiTqk";
export var description = "index-module--description--bvHnK";
export var hero = "index-module--hero--NppQX";
export var ousterBlogPreviewCard = "index-module--ousterBlogPreviewCard--qdGep";
export var previewCard = "index-module--previewCard--VuJuA";
export var title = "index-module--title--D6329";
export var titleContainer = "index-module--titleContainer--GgR-X";